<template>
  <button @click="deactivateSubscription" class="btn btn-accent">
    Деактивировать
  </button>
</template>

<script>
import {useStore} from "vuex";

export default {
  props: {
    id: Number,
    forCompany: Boolean,
  },
  setup(props) {
    const store = useStore();

    const deactivateSubscription = () => {
      store.dispatch("subscription/expireSubscription", {subscriptionId: props.id, type: props.forCompany ? 'company' : 'user'});
    }

    return {
      deactivateSubscription,
    }
  }
}
</script>